import { Button, ButtonProps } from "@mui/material";

interface Props extends ButtonProps {
    action?: () => void;
};

const ConfirmationButton = ({ action, sx, ...props }: Props) => {
    return (
        <Button
            onClick={action}
            variant="contained"
            {...props}
            sx={{
                borderRadius: 7,
                textTransform: "none",
                fontSize: "16px",
                py: 1.2,
                px: 2,
                ...sx
            }}
        />
    );
}

export default ConfirmationButton;